// Initial uses for this is to take an object for Formik touched and errors and  make all (nested) properties to false
// goes three levels deep
import _ from 'lodash'
export default function objToFalse(obj) {
	return _.mapValues(obj, r => {
		if(typeof r == 'object') {
			return _.mapValues(r, ir => {
				if(typeof ir == 'object') {
					return _.mapValues(ir, () => {
						return false
					})
				}
				else {
					return false
				}
			})
		}
		else {
			return false
		}
		
	})
}